// extracted by mini-css-extract-plugin
export default {"cards":"RatingDetails_legacy_cards__8Nmc9","placeholder":"RatingDetails_legacy_placeholder__qOGlj"};